import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Bekræft e-mailadresse',
  [OnboardingStep.BusinessInfo]: 'Tilføj dine butiksoplysninger',
  [OnboardingStep.PersonalInfo]: 'Tilføj dine personlige oplysninger',
  [OnboardingStep.ShippingInfo]: 'Tilføj dine leveringsoplysninger',
  [OnboardingStep.BankInfo]: 'Tilføj bankoplysninger til udbetalinger',
  [OnboardingStep.TaxInfo]: 'Er din virksomhed momsregistreret?',
  [OnboardingStep.BusinessDocs]: 'Dokumentation for virksomhed',
  [OnboardingStep.PersonalDocs]: 'Dokumentation for identitet',
  [OnboardingStep.InfoSubmission]: 'Få udbetalt',
  confirm_info_gateway: 'Få udbetalt – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Betalingsoplysninger',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobilapp',
  [OnboardingStep.DeliveryStructure]: 'Leveringsstruktur',
  [OnboardingStep.Contract]: 'Kontrakt',
  [OnboardingStep.ContractPayment]: 'Kontraktbetaling',
  [OnboardingStep.PromoCode]: 'Rabatkode',
};
